import "./CartDisplay.css";
import { useCart } from "../../contexts/Cart/CartContext";
import FullCartDisplay from "../../contexts/Cart/FullCartDisplay";
import OrderSummaryComponent from "./OrderSummary";
import { useState, useEffect } from "react";
import config from "../../config";
import bear_shopping from "../../images/bear_shopping_cart.png";
import { useNavigate } from "react-router-dom";
import YouAreSupportingDisplay from "../../contexts/Cart/ParticipantSupportingDisplay";
import { FundraiserParticipantShop } from "../../Interfaces/FundraiserRole";
import FreeShippingProgressBar from "../../contexts/Cart/FreeShippingProgressBar";
import RefactoredOrderSummary from "../../components/Checkout/RefactoredOrderSummary";
const BASE_API = config.API_BASE_URL;

const CartDisplayPage = () => {
  const {
    state,
    dispatch,
    subtotal,
    totalItems,
    freeShippingThreshold,
    baseShippingCost,
  } = useCart();
  const [participantName, setParticipantName] = useState(
    state.fundraiser_participant?.full_name || ""
  );
  const [fundraiserName, setFundraiserName] = useState(
    state.fundraiser_participant?.fundraiser_name || ""
  );

  const { cart } = state;
  const DONATION_ID = config.DONATION_ITEM_ID;
  const BUYOUT_ID = config.BUYOUT_ITEM_ID;

  const navigate = useNavigate();

  const handleRemove = (id: string) => {
    dispatch({ type: "REMOVE_ITEM", payload: id });
  };

  const handleQuantityChange = (itemId: string, newQuantity: number) => {
    dispatch({
      type: "UPDATE_ITEM_QUANTITY",
      payload: { id: itemId, quantity: newQuantity },
    });
  };

  const handleContinueShopping = () => {
    const url = state.fundraiser_participant
      ? `/participant-shop/part-id/${state.fundraiser_participant?.participant_code}`
      : "/register-or-shop";

    navigate(url); // Navigate to the constructed URL
  };

  // const updateParticipantInfo = (participant: FundraiserParticipantShop) => {
  //   state.fundraiser_participant = participant;
  //   setFundraiserName(participant.fundraiser_name);
  //   setParticipantName(participant.full_name);
  // };

  const donation = cart.reduce((sum, item) => {
    if (item.sku === DONATION_ID || item.sku === BUYOUT_ID) {
      return sum + item.price * item.quantity;
    }
    return sum;
  }, 0);
  const price = subtotal - donation;

  // Fetch free shipping threshold from an API
  useEffect(() => {
    document.title = "Cart";
  }, []);

  if (freeShippingThreshold === null) {
    return <div>Loading...</div>;
  }
  return (
    <div className="checkout-page-container">
      {/* Left Column: Bear Icon and Cart Items */}
      <div className="checkout-page-left-column">
        {/* Header with Continue Shopping and Cart Title */}
        <div className="checkout-cart-page-cart-header">
          <div className="header-content">
            <div className="checkout-cart-page-continue-shopping">
              <span
                onClick={handleContinueShopping}
                className="continue-shopping-link"
              >
                Continue Shopping
              </span>
            </div>
            <div className="checkout-cart-page-cart-title">
              <h1>Shopping Cart</h1>
              <p>You have {totalItems} items in your cart</p>
            </div>
          </div>
          {/* Bear Icon */}
          <div className="checkout-cart-page-bear-icon-container">
            <img
              src={bear_shopping}
              alt="Bear Icon"
              className="checkout-cart-page-bear-icon"
            />
          </div>
        </div>

        {/* Full Cart Display */}
        <div className="checkout-page-cart-items">
          <FullCartDisplay
            onRemoveItem={handleRemove}
            onQuantityChange={handleQuantityChange}
          />
        </div>
      </div>

      {/* Right Column: Participant Info and Order Summary */}
      <div className="checkout-page-right-column">
        {/* Participant Info */}
        <div className="checkout-cart-and-participant-container">
          <YouAreSupportingDisplay
            participantName={participantName}
            fundraiserName={fundraiserName}
            //handleApply={updateParticipantInfo}
          />
        </div>
        <div
          style={{ width: "100%", display: "flex", justifyContent: "center" }}
        >
          <FreeShippingProgressBar
            current={price}
            max={freeShippingThreshold}
          />
        </div>

        {/* Order Summary */}
        <div className="order-summary">
          <RefactoredOrderSummary onShippingStep={false} />
        </div>
      </div>
    </div>
  );
};

export default CartDisplayPage;
